import { NgClass } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { MessageType } from 'enums/MessageType';
import { DashboardElementModel } from 'models/generated/Identity.Api.Models.DashboardElement';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription, firstValueFrom } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { PushService } from 'services/push.service';
import { DashboardService } from 'services/dashboard.service';
import { ViewDashboardElementComponent } from './view-dashboard-element.component';
import { DashboardType } from 'enums/DashboardType';

@Component({
	selector: 'list-dashboard',
	templateUrl: './list-dashboard.component.html',
	imports: [Layout, ListView, NgClass, TranslatePipe]
})
@ComponentUrl('list-dashboard')
@CredentialRequired(CredentialType.DashboardAccessFull)
export class ListDashboardComponent implements OnDestroy {

	private dashboardChangeSubscription: Subscription;
	dashboardElements: DashboardElementModel[] = [];
	selectedDashboardElementId?: string;
	activeElementView?: ViewDashboardElementComponent;
	dashboardType = DashboardType;

	constructor(private readonly navigation: NavigationService,
		private readonly pushService: PushService,
		private readonly dashboardService: DashboardService,
		private readonly notification: NotificationService) {

		this.updateDashboardElementsList();

		this.dashboardChangeSubscription = this.pushService.onChanges<{ dashboardElementId: string }>(MessageType.DashboardChanges).subscribe(() => {
			this.updateDashboardElementsList()
		});
	}

	async updateDashboardElementsList() {
		this.dashboardElements = await this.dashboardService.getDashboardElements();
		if (this.activeElementView && !this.dashboardElements.some(de => de.id == this.selectedDashboardElementId)) {
			this.navigation.closeView(this.activeElementView);
		}
	}

	createOrEditDashboardElement(elementId?: string) {
		this.selectedDashboardElementId = elementId;
		this.navigation.openRelativeView(this, 'dashboard-admin', ViewDashboardElementComponent).then(view => {
			this.activeElementView = view;
			view.dashboardElementId = this.selectedDashboardElementId;
		});
	}

	canDeleteDashboardElement(element: DashboardElementModel) {
		return element.teamDashboardElements.length === 0;
	}

	async deleteDashboardElement(element: DashboardElementModel) {
		if (!this.canDeleteDashboardElement(element)) return;
		if (await firstValueFrom(this.notification.confirm('dashboard.prompt-for-delete-element', { 'dashboard.name': element.name })))
			this.dashboardService.deleteDashboardElement(element);
	}

	ngOnDestroy() {
		this.dashboardChangeSubscription.unsubscribe();
	}
}
